import { render, staticRenderFns } from "./InputCategory.vue?vue&type=template&id=4edef50a&scoped=true&"
import script from "./InputCategory.vue?vue&type=script&lang=js&"
export * from "./InputCategory.vue?vue&type=script&lang=js&"
import style0 from "./InputCategory.vue?vue&type=style&index=0&id=4edef50a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edef50a",
  null
  
)

export default component.exports